import script from "./Locale.vue?vue&type=script&setup=true&lang=js"
export * from "./Locale.vue?vue&type=script&setup=true&lang=js"

import "./Locale.vue?vue&type=style&index=0&id=11c5349c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c5349c"]])

export default __exports__